module.exports = __webpack_public_path__ + "img/australia.182bb64f.svg";